import React, { useState } from 'react';
import SupplierBadge from './SupplierBadge';
import SupplierLocation from './SupplierLocation';

function SupplierCardWithMatch({
  name,
  shortcode,
  caption,
  logo_url,
  tier,
  city,
  state,
  country,
  rating,
  year_established,
  match,
}) {
  const [feedback, setFeedback] = useState(match?.rfq_feedback || null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [animatingButton, setAnimatingButton] = useState(null);

  const handleFeedback = async (action) => {
    if (!match || isSubmitting) return;
    
    setIsSubmitting(true);
    setAnimatingButton(action);
    
    // Reset animation after animation completes
    setTimeout(() => setAnimatingButton(null), 300);
    
    try {
      const response = await fetch(`/api/v1/matches/${match.id}/${action}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        },
      });
      
      if (response.ok) {
        const data = await response.json();
        setFeedback(action === 'like' ? 'liked' : 'disliked');
      }
    } catch (error) {
      console.error('Error sending feedback:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="supplierCard">
      <div className="supplierCardContent">
        <a
          href={`/supplier_profiles/${shortcode}`}
          className="supplierCardLink"
          target="_blank"
          rel="noopener noreferrer"
        >
          {logo_url && (
            <div style={{ position: 'relative' }}>
              <img src={logo_url} alt={name} className="supplierCardLogo" />
              {match && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: '36px',
                    left: '16px',
                    display: 'flex',
                    gap: '8px',
                  }}
                  onClick={(e) => e.preventDefault()}
                >
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      handleFeedback('like');
                    }}
                    style={{
                      width: '36px',
                      height: '36px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255, 255, 255, 0.95)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: isSubmitting ? 'not-allowed' : 'pointer',
                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.2s ease',
                      border: '1px solid rgba(0, 0, 0, 0.1)',
                      transform: animatingButton === 'like' ? 'scale(1.2)' : 'scale(1)',
                    }}
                    onMouseEnter={(e) => {
                      if (!isSubmitting) e.currentTarget.style.transform = 'scale(1.1)';
                    }}
                    onMouseLeave={(e) => {
                      if (animatingButton !== 'like') e.currentTarget.style.transform = 'scale(1)';
                    }}
                  >
                    <i 
                      className={`ph${feedback === 'liked' ? '-fill' : ''} ph-thumbs-up`}
                      style={{
                        fontSize: '18px',
                        color: '#4a4a4a',
                        transition: 'transform 0.2s ease',
                        transform: animatingButton === 'like' ? 'scale(1.1)' : 'scale(1)',
                      }}
                    ></i>
                  </div>
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      handleFeedback('dislike');
                    }}
                    style={{
                      width: '36px',
                      height: '36px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255, 255, 255, 0.95)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: isSubmitting ? 'not-allowed' : 'pointer',
                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.2s ease',
                      border: '1px solid rgba(0, 0, 0, 0.1)',
                      transform: animatingButton === 'dislike' ? 'scale(1.2)' : 'scale(1)',
                    }}
                    onMouseEnter={(e) => {
                      if (!isSubmitting) e.currentTarget.style.transform = 'scale(1.1)';
                    }}
                    onMouseLeave={(e) => {
                      if (animatingButton !== 'dislike') e.currentTarget.style.transform = 'scale(1)';
                    }}
                  >
                    <i 
                      className={`ph${feedback === 'disliked' ? '-fill' : ''} ph-thumbs-down`}
                      style={{
                        fontSize: '18px',
                        color: '#4a4a4a',
                        transition: 'transform 0.2s ease',
                        transform: animatingButton === 'dislike' ? 'scale(1.1)' : 'scale(1)',
                      }}
                    ></i>
                  </div>
                </div>
              )}
            </div>
          )}
          <div className="supplierCardNameContainer" style={{ minHeight: '2.5rem' }}>
            <p className="title is-6 mb-1 supplierCardName">{name}</p>
          </div>
          <div className="supplierCardDescriptionContainer" style={{ minHeight: '3rem' }}>
            <p className="supplierCardDescription">{caption}</p>
          </div>
          <div className="my-3" style={{ minHeight: '2rem' }}>
            <SupplierBadge tier={tier} />
          </div>
          <div style={{ minHeight: '1.5rem' }}>
            <SupplierLocation city={city} state={state} country={country} />
          </div>
          <div className="supplierCardDetails" style={{ minHeight: '1.5rem' }}>
            {rating && (
              <span className="mr-4">
                {rating} <i className="ph-fill ph-star reviewStar"></i>
              </span>
            )}
            {year_established && <span>Est. {year_established}</span>}
          </div>
        </a>
      </div>
      
      <a
        href={`/supplier_profiles/${shortcode}`}
        className="button is-rounded contactSupplierButton"
        target="_blank"
        rel="noopener noreferrer"
      >
        Contact supplier
      </a>
    </div>
  );
}

export default SupplierCardWithMatch;